import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import HackerNewsAirspace from './pages/HackerNewsAirspace';
import Portfolio from './pages/Portfolio';
import Works from './pages/Works.tsx';

function App() {

  return (
    <Router>
      <div className="content">
        <Routes>
          <Route path="/" element={<Portfolio/>} />
          <Route path="/works" element={<Works/>} />
          <Route path="/hackernews" element={<HackerNewsAirspace/>} />
        </Routes>
      </div>
      <Analytics/>
    </Router>
  );
}

export default App;
